import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'redux-little-router';
import { map } from 'lodash';
import { remotePaths, routeMap } from 'router/routes';
import { injectParamsInRoute } from 'utils';
import Button from 'components/Button';
import Loading from 'components/Loading';
import Warning from 'components/Warning';

import YaMapComponent from 'modules/App/components/YaMapComponent';
import getInspectionFields from './private/getInspectionFields';
import { DEFAULT_ERROR_TEXT } from 'modules/Contacts/components/Appointment/constants';

import styles from './Appointment.module.scss';
import { InfoTable, InfoTableRow } from 'modules/Contacts/components/Appointment/InfoTable';
import InfoMessage from 'components/InfoMessage';
import PageContentWrapper from 'modules/Contacts/components/Appointment/PageContentWrapper';
import { ReactComponent as PrintIcon } from './assets/ic-print.svg';
import CancelModal from 'modules/Contacts/components/Appointment/components/CancelModal';
import InfoModal from 'modules/Contacts/components/Appointment/components/InfoModal';
import Storage from 'services/Storage';
import cn from 'classnames';
import config from 'config';

export default class Appointment extends Component {
  static propTypes = {
    getAppointment: PropTypes.func.isRequired,
    cancelAppointment: PropTypes.func.isRequired,
    bookingId: PropTypes.string,
    isDataPresented: PropTypes.bool,
    bookingDetails: PropTypes.object,
    isCancelingAppointment: PropTypes.bool,
    cancelError: PropTypes.bool,
    isCanceled: PropTypes.bool,
    isLoading: PropTypes.bool,
  };

  state = {
    showCancelModal: false,
    showInfoModal: false,
    isAnonymous: !Storage.getItem(config.tokenItemName),
  };

  componentDidMount() {
    const { bookingId, isDataPresented, getAppointment } = this.props;
    if (!isDataPresented) {
      getAppointment(bookingId);
    }
  }

  componentDidUpdate(prevProps) {
    const { cancelError, isCanceled } = prevProps;

    if (
      (this.props.cancelError && this.props.cancelError !== cancelError) ||
      (this.props.isCanceled && this.props.isCanceled !== isCanceled)
    ) {
      this.openInfoModal();
    }
  }

  closeCancelModalHandle = () => {
    this.setState({ showCancelModal: false });
  };

  openInfoModal = () => {
    this.setState({ showInfoModal: true });
  };

  cancelAppointment = () => {
    const { cancelAppointment, bookingId } = this.props;
    cancelAppointment(bookingId);
    this.setState({ showCancelModal: false });
  };

  handleInfoModalClose = () => {
    this.setState({ showInfoModal: false });
  };

  renderLoading = () => {
    return (
      <div className="white-block white-block__pad40 contacts page__mobile">
        <div className="loading-container">
          <Loading />
        </div>
      </div>
    );
  };

  renderUserHistoryLink = () => {
    const { bookingDetails } = this.props;
    const { isAnonymous } = this.state;
    if (isAnonymous) {
      return null;
    }
    if (!bookingDetails.isCanceled) {
      return (
        <div>
          Данный талон доступен в разделе{' '}
          <a href={remotePaths.profileActivityHistory}>История действий</a>. В случае изменения
          планов в данном режиме Вы можете отменить запись на прием
        </div>
      );
    }
    return (
      <div>
        Вернуться к разделу <a href={remotePaths.profileActivityHistory}>История действий</a>.
      </div>
    );
  };

  renderAppointment = () => {
    const { bookingDetails, bookingId, isCancelingAppointment, isCanceled } = this.props;
    const { showCancelModal, showInfoModal, isAnonymous } = this.state;
    if (!bookingDetails) {
      return null;
    }

    const visitTime = bookingDetails.visitTime;
    const inspection = bookingDetails.serviceWay
      ? { ...bookingDetails.taxAuthority, way: bookingDetails.serviceWay }
      : bookingDetails.taxAuthority;
    const taxCode = inspection.taxCode || inspection.codeSOUN;
    const link = injectParamsInRoute(routeMap.contactsDetail, { id: taxCode });
    const ticketHref = {
      pathname: routeMap.openPdf,
      query: {
        pdf: `ticket?appointmentNumber=${bookingId}`,
        filename: `ticket-${bookingId}.pdf`,
      },
    };

    const title = bookingDetails.isCanceled ? 'Запись на приём отменена' : 'Вы записаны на приём';
    const inspectionFields = getInspectionFields(inspection);
    return (
      <PageContentWrapper>
        <div>
          <h2 className="page-title">
            {title}
            <span className={styles.colorGrey}>{` ${visitTime.format(
              'DD MMMM YYYY, HH:mm',
            )}`}</span>
          </h2>
          <div className="page_margin20">
            {isAnonymous ? (
              `${taxCode} - ${inspection.name}`
            ) : (
              <Link href={link}>
                {taxCode} - {inspection.name}
              </Link>
            )}
          </div>

          <div className={styles.appointmentInfo}>
            <div className={styles.tableBlock}>
              <InfoTable>
                <InfoTableRow title={'Услуга'} value={bookingDetails.serviceName} />
                {bookingDetails.pincode ? (
                  <InfoTableRow title={'PIN-код'} value={bookingDetails.pincode} />
                ) : (
                  <InfoTableRow title={'Номер окна'} value={bookingDetails.window} />
                )}
              </InfoTable>

              <InfoTable>
                {map(inspectionFields, ({ title, value }, index) => (
                  <InfoTableRow key={index} title={title} value={value} />
                ))}
              </InfoTable>
            </div>
            <div className={styles.mapBlock}>
              <YaMapComponent
                addressId={inspection.taxCode || inspection.codeSOUN}
                address={inspection.address}
              />
            </div>
          </div>

          <InfoMessage>
            <div>
              {bookingDetails.pincode ? (
                <span>
                  Внимание! При обращении в инспекции ФНС России при себе необходимо иметь паспорт
                  гражданина Российской Федерации. Для получения выбранной услуги в зале Налогового
                  органа, Вам необходимо до назначенного времени получить талон электронной очереди.
                  Для этого в терминале электронной очереди необходимо ввести указанный PIN-код и
                  получить распечатанный талон электронной очереди.
                </span>
              ) : (
                <span>
                  Внимание! При обращении в инспекции ФНС России при себе необходимо иметь паспорт
                  гражданина Российской Федерации.
                </span>
              )}
            </div>
            {this.renderUserHistoryLink()}
          </InfoMessage>
          {bookingDetails.email && (
            <InfoMessage isShowIcon={false} className={styles.emailBlock}>
              <div>
                Талон со сведениями о записи отправлен на электронную почту&nbsp;
                <span className={styles.bold}>{bookingDetails.email}</span>
              </div>
            </InfoMessage>
          )}
        </div>
        <div className={styles.buttonBlock}>
          <div>
            {isAnonymous ? (
              <Button
                type={'button'}
                hasWrapper={false}
                extraClassName={styles.button}
                onClick={window.print}
                isLinkStyled={true}
              >
                <PrintIcon className={styles.icon} />
                ПЕЧАТЬ
              </Button>
            ) : (
              <Button
                type={'button'}
                hasWrapper={false}
                extraClassName={styles.button}
                href={ticketHref}
                isLinkStyled={true}
                target="_blank"
              >
                <PrintIcon className={styles.icon} />
                ПЕЧАТЬ
              </Button>
            )}
          </div>

          <div>
            {!bookingDetails.isCanceled && (
              <Button
                type={'button'}
                hasWrapper={false}
                extraClassName={styles.button}
                color={'orange'}
                onClick={() => this.setState({ showCancelModal: true })}
              >
                {!isCancelingAppointment ? 'Отменить посещение' : <Loading isLight={true} />}
              </Button>
            )}
            {isAnonymous && (
              <Button
                type={'button'}
                hasWrapper={false}
                extraClassName={styles.button}
                href={routeMap.login}
              >
                Закрыть
              </Button>
            )}
          </div>

          <CancelModal
            appointment={bookingDetails}
            isShowModal={showCancelModal}
            onClose={this.closeCancelModalHandle}
            onSubmit={this.cancelAppointment}
          />
          <InfoModal
            isCanceled={isCanceled}
            isShowModal={showInfoModal}
            onClose={this.handleInfoModalClose}
          />
        </div>
      </PageContentWrapper>
    );
  };

  renderPageContent = () => {
    const { isLoading, isDataPresented } = this.props;
    if (isLoading) {
      return this.renderLoading();
    }
    if (isDataPresented) {
      return this.renderAppointment();
    }

    return <Warning message={DEFAULT_ERROR_TEXT} style={{ paddingTop: '4px' }} />;
  };

  render() {
    const { isAnonymous } = this.state;
    return <div className={cn({ page: !isAnonymous })}>{this.renderPageContent()}</div>;
  }
}
